import React from 'react';
import { connect } from 'react-redux';

class Profiles extends React.Component {

    render() {
        let socialLinks = []
        if (typeof this.props.socialLinks !== undefined && this.props.socialLinks.length > 0) {
            //Sort it by Id
            this.props.socialLinks.sort((a, b) => {
                return a.displayName.localeCompare(b.displayName);
            });

            socialLinks = this.props.socialLinks.map((socialLink) => {
                return <div key={socialLink.displayName} className="o-grid__col-xl-4  o-grid__col-sm-6">
                                    <div className="o-content">
                                        <a href={socialLink.socialMediaLink} target="_blank" className="t-link-container">
                                            <div className="o-media  o-media--block">
                                                <div className="o-media__figure">
                                                    <div className="c-profile__icon">
                                                        <i className={socialLink.iconClassName}></i>
                                                    </div>
                                                </div>
                                                <div className="o-media__body  o-content__body">
                                                    <h3 className="t-link-container__item">
                                                        {socialLink.displayName}
                                                    </h3>
                                                    <p>
                                                       
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
            });


                                
        }
        return (

            <section className="o-section  t-section  ">

                <div className="o-section__header-bg  t-section__header"></div>
                <div className="o-section__content-bg  t-section__content"></div>

                <div className="o-container">
                    <div className="o-section__container">

                        <header className="o-section__header  t-section__header">
                            <div className="o-content">
                                <h2 className="o-section__heading">
                                    Profiles
                                </h2>
                                <div className="o-content__body  o-section__description">
                                   {/* Busy as usual*/}
                                </div>
                            </div>
                        </header>

                        <div className="o-section__content  t-section__content  ">

                            <div className="o-grid">
                                {socialLinks}


                            </div>

                        </div>

                    </div> 
                </div> 

            </section> 

        );
    }
}

const mapStateToProps = (state) => {
    return {
        introduction: state.introduction.profile.introJson,
        socialLinks: state.introduction.profile.socialLinks
    };
};

export default connect(mapStateToProps)(Profiles);


// WEBPACK FOOTER //
// ./src/components/Profiles.js